import { Component } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';


@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  standalone: true,
  imports:[CommonModule,SharedModule],
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  constructor(public toastService: ToastService) { }
  removeToast(index: number): void {
    this.toastService.toasts.splice(index, 1);
  }
}
